import { Component, AfterViewInit, Renderer2, Inject, OnInit } from '@angular/core';
import { AuthenticationService, ProfileService, AlertService,CompanyService } from '../_services/index';
import { environment } from '../../environments/environment';
import { FormBuilder, FormsModule } from '@angular/forms';
import * as Prism from 'prismjs';
import {Router, ActivatedRoute} from "@angular/router"
import { DOCUMENT } from '@angular/platform-browser';
import { ThemeService } from 'ng2-charts';
import * as moment from 'moment'
@Component({
  selector: 'app-home',
  templateUrl: './profile.component.html',
  styleUrls: ['./profile.component.scss']
})
export class ProfileComponent implements OnInit {
    public authorized:any;
    public profile:any;
    public user:any;
    public roles:any;
    public param:any;
    public business:any;
    public a:any;
    BirthDate:Date;
    constructor(
        public as: AuthenticationService,
        public alertService:AlertService,
        public companyService:CompanyService,
        public profileService: ProfileService,
        private route: ActivatedRoute,
        private router: Router,
        @Inject(DOCUMENT) private _document,
    ){
        this.authorized = this.as.checkAuthentication();
        if(!this.authorized.authorized){
            this.router.navigate(['/login'])
        }
    }

    ngOnInit() {
        this.profileService.cast.subscribe(response => {
            this.user = response;
        }, error => {
        })
        this.profileService.getRole().subscribe(response => {
            this.roles = response;  
        }, error => {
        })
        this.route.queryParams.subscribe(params => {
            this.a=JSON.stringify(params);
        });
        this.param = {
            page:JSON.parse(this.a).page?JSON.parse(this.a).page:1,
            offset:JSON.parse(this.a).offset?JSON.parse(this.a).offset:100,
            orderby:"[['name','"+(JSON.parse(this.a).name?JSON.parse(this.a).name:'ASC').toString()+"']]",
            name:JSON.parse(this.a).name?JSON.parse(this.a).name:'ASC',
        }
        this.getCompany(this.param);
        if (this.route.snapshot.params && this.route.snapshot.params.id) {
            this.getProfile(this.route.snapshot.params.id)
        }else{
            this.profile = {
                firstName:null,
                lastName:null,
                email:null,
                companyId:'',
                role:''
            }
        }
    }
    getCompany(data){
        this.companyService.getBussiness(data).subscribe(response => {
            this.business = response; 
        }, error => {
        })
      }
    getProfile(data){
        this.profileService.getUser(data).subscribe(response => {
            this.profile = response;
            this.profile.birthday = moment(this.profile.birthday).format('YYYY-MM-DD');
            if(!response){
                this.alert({reason:'No se ha podido cargar el usuario.', type:"danger"});
                this.router.navigate(['/usuarios']);
            }
        }, error => {
            this.alert({reason:'No se ha podido cargar el usuario.', type:"danger"});
            this.router.navigate(['/usuarios']);
        })
    }
    delete(){
        this.profileService.deleteUser(this.profile).subscribe(response => {
            this.alert({reason:'Tu usuario ha sido eliminado con éxito.', type:"success"});
            this.router.navigate(['/usuarios']);
        }, error => {
            this.alert({reason:'Tu usuario no ha sido eliminada, intentalo nuevamente.', type:"danger"});
        })
    }
    getSave(){
        if(this.route.snapshot.params.id){
            this.profile.role = this.profile.role.name?this.profile.role.name:this.profile.role;
            this.profileService.updateUser(this.profile).subscribe(response => {
                this.alert({reason:'Tu usuario ha sido actualizado con éxito.', type:"success"});
                this.router.navigate(['/usuarios']);
            }, error => {
                this.alert({reason:'Tu usuario no ha sido actualizado, intentalo nuevamente.', type:"danger"});
            })
        }else{
            if(this.profile.role == 'root' || this.profile.role == 'super'){
                this.profile.companyId = '';
            }
            this.profileService.newUser(this.profile).subscribe(response => {
                this.alert({reason:'Tu usuario ha sido creado con éxito.', type:"success"});
                this.router.navigate(['/usuarios']);
            }, error => {
                this.alert({reason:'Tu usuario no ha sido creado, intentalo nuevamente.', type:"danger"});
            })
        }
    }
    alert(data){
        this.alertService.updateAlert(data).subscribe(()=>{
            setTimeout(() => {
            this.alertService.deleteAlert().subscribe();
            }, 8000);
        })
    }
    
}

